import moment from 'moment/moment';
import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { salesforceSendFormNumber, savePaymentDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

const PosDateCheque = ({selectedInstFeeDetail,currency,feeDetail,userDetail}) => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [expiryDate, setExpiryDate] = useState({ value: '', error: ''  });
    const [transactionDate, setTransactionDate] = useState({ value: '', error: ''  });
    const [encashmentDate, setEncashmentDate] = useState({ value: '', error: ''  });
    const [transactionType, setTransactionType] = useState({ value: '', error: ''  });
    const [transactionNumber, setTransactionNumber] = useState({ value: '', error: ''  });
    const [receipt,setReceipt] = useState({name:'',value: "",error: ""}); 

    const currentDate = moment().format('YYYY-MM-DD');
    const minDate = moment(currentDate).subtract(30, 'days').format('YYYY-MM-DD');
    const minEncashmentDate=moment(currentDate).format('YYYY-MM-DD')
    const maxEncashmentDate=moment(currentDate).add(1,'years').format('YYYY-MM-DD')

    const {id,form_num} = userDetail !==undefined && userDetail
    const {installment_type,net_payable_amount,scholarship_amount,scholarship_percentage,total_fee} = feeDetail !==undefined && feeDetail


     const validation = () => {
        let amountRegex = /^[0-9]+([.][0-9]+)?$/;
        const nameRegex = /^[a-zA-Z() ]+$/;
        let formIsValid = true

        // Student Name

        if (!transactionDate.value) {
            formIsValid = false
            let msg = "Please select date"
            setTransactionDate({ ...transactionDate, error: msg })
        }
        if (!encashmentDate.value) {
            formIsValid = false
            let msg = "Please select date"
            setEncashmentDate({ ...encashmentDate, error: msg })
        }

        if (!receipt.value) {
            formIsValid = false
            let msg = "Please please upload receipt"
            setReceipt({ ...receipt, error: msg })
        }
        if (!transactionNumber.value) {
            formIsValid = false
            let msg = "Please Cheque Number"
            setTransactionNumber({ ...transactionNumber, error: msg })
        }
        else if (!amountRegex.test(transactionNumber.value)) {
            formIsValid = false
            let msg = "Only numbers should be acceptable No Alphabets";
            setTransactionNumber({ ...transactionNumber, error: msg })
        }


        if (formIsValid) {
            setTransactionNumber({ ...transactionNumber, error: '' })
            setReceipt({ ...receipt, error: '' })
            setTransactionDate({ ...transactionDate, error: '' })
            setEncashmentDate({ ...encashmentDate, error: '' })
        }
        return formIsValid;
    }

    const handleReceiptChange=(e)=>{
        e.preventDefault();
        let receiptName=e.target.name
        const value=e.target.files
        setReceipt({...receipt,name:receiptName,value:value[0],error:''})
    }

    const onSubmit = async(e) => {
        e.preventDefault();

        if(validation()){
            setLoading(true)
            const formDataToSend = new FormData();
            formDataToSend.append('student_id', id);
            formDataToSend.append('amount', selectedInstFeeDetail?.amount);
            formDataToSend.append('pay_transaction_id',transactionNumber.value);
            formDataToSend.append('cheque_number',transactionNumber.value)
            formDataToSend.append('cheque_date',transactionDate.value)
            formDataToSend.append('transaction_date',currentDate)
            formDataToSend.append('encashment_date',encashmentDate.value)
            formDataToSend.append('transaction_receipt',receipt.value);
            formDataToSend.append('payment_mode','offline');
            formDataToSend.append('payment_type',3);
            formDataToSend.append('installments_id',selectedInstFeeDetail?.installment_id);
            formDataToSend.append('installment_type',selectedInstFeeDetail?.installment_number ==0? 'lumpsum': installment_type);
            formDataToSend.append('installments_number',selectedInstFeeDetail?.installment_number);
            formDataToSend.append('scholarship_amount',scholarship_amount);
            formDataToSend.append('net_payable_amount',net_payable_amount);
            formDataToSend.append('scholarship_percentage',scholarship_percentage);
            formDataToSend.append('actual_inst_amt',selectedInstFeeDetail?.amount);
            formDataToSend.append('course_fee',total_fee);

            try {
                await savePaymentDetail(formDataToSend).then((res) => {
                    
                    if(res.status){
                        setLoading(false)
                        salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
                        swal(res.message,'','success')
                        navigate('/student/dashboard');
                    }
                    else{
                        setLoading(false)
                        swal(res.message,'Try Again!','error')
                    }
                })
            } catch (error) {
                console.log('offline error..',error)
            }
        }
    
}
  return (
    <form onSubmit={onSubmit} className="hold_mandatoryField">
            <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                    <label className='form-label' >Amount</label>
                        <input type="text" disabled className="form-control"  value={selectedInstFeeDetail?.amount} placeholder="Enter Amount"
                            onChange={(e) => {}}
                            name="amount" />
                </div>
                <div className="col-lg-6 mb-3">
                        <label className='form-label'>Cheque Number <span>*</span></label>
                        <input type="text" className="form-control" value={transactionNumber.value}
                            onChange={(e) => {setTransactionNumber({ ...transactionNumber, value: e.target.value, error: '' }); }}
                            placeholder="Enter cheque number " name="trxn_no" />
                        {transactionNumber.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{transactionNumber.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                        <label className='form-label' htmlFor="floatingInput">Cheque Date <span>*</span></label>
                        <input type="date" className="form-control" min={minDate} max={currentDate} placeholder="Enter transaction date"
                            value={transactionDate.value}
                            onChange={(e) => {setTransactionDate({ ...transactionDate, value: e.target.value, error: '' });}}
                            name="trxn_date" />
                        {transactionDate.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{transactionDate.error}</div>}
                </div>
                <div className="col-lg-6 mb-3">
                        <label htmlFor="floatingInput" className='form-label'>Encashment Date <span>*</span></label>
                        <input type="date" className="form-control" min={minEncashmentDate} max={maxEncashmentDate} placeholder="Enter encashment date"
                            value={encashmentDate.value}
                            onChange={(e) => {setEncashmentDate({ ...encashmentDate, value: e.target.value, error: '' });}}
                            name="encashmentdate" />
                        {encashmentDate.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{encashmentDate.error}</div>}
                </div>
                <div className="col-lg-6 ">
                        <label className="form-label">Upload Receipt <span>*</span></label>
                        <input className="form-control" type="file" name={receipt.name} 
                        accept="image/png, image/gif, image/jpeg, docx, doc, pdf" 
                        onChange={(e) => handleReceiptChange(e)}/>
                    {receipt.error.length > 0 && <div className='invalid-field text-danger fw-semibold mt-1'>{receipt.error}</div>}
                </div>
                
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6  d-flex align-items-center  col-sm-6 col-6 mb-3">
                {loading ? (<button type="submit" disabled className="btn btn-primary">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Sending ...</button>) : 
                    <button type="submit" className="btn btn-primary">Submit</button>
                }
                    <Link to="/student/dashboard" className="btn btn-default ms-2 ms-lg-2 ">Cancel</Link>
                </div>

            </div>
        </form>
  )
}

export default PosDateCheque